import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { ShoppingBag, Plane } from "lucide-react";
import { Logo } from "../components/Logo";
import { Input } from "../components/ui/input";
import { useAuth } from "../context/AuthContext";
import { apiError } from "../lib/api";

export default function Register() {
  const { register, user } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "", role: "titiper" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  useEffect(() => { if (user) navigate("/home", { replace: true }); }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await register(form);
      toast.success("Akun dibuat! Selamat datang di BAWAIN 🎉");
      navigate("/home", { replace: true });
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setBusy(false);
    }
  };

  const roles = [
    { key: "titiper", title: "TITIPER", desc: "Saya mau titip barang dari luar kota/negara", icon: ShoppingBag },
    { key: "bawainer", title: "BAWAINER", desc: "Saya sering bepergian & mau bawakan barang", icon: Plane },
  ];

  return (
    <div className="min-h-screen bg-navy flex flex-col">
      <div className="p-5"><Link to="/"><Logo light /></Link></div>
      <div className="flex-1 flex items-center justify-center px-4 pb-10">
        <div className="w-full max-w-md bg-white rounded-3xl p-7 shadow-lift animate-scale-in">
          <h1 className="font-heading font-extrabold text-2xl text-navy">Daftar BAWAIN</h1>
          <div className="grid grid-cols-2 gap-3 mt-4">
            {roles.map((r) => {
              const Icon = r.icon;
              const active = form.role === r.key;
              return (
                <button key={r.key} type="button" data-testid={`role-${r.key}`}
                  onClick={() => setForm((f) => ({ ...f, role: r.key }))}
                  className={`text-left rounded-2xl p-3 border-2 transition-colors ${
                    active ? "border-lime bg-lime-light/40" : "border-black/10 hover:border-black/20"}`}>
                  <Icon size={20} className="text-navy" />
                  <div className="font-heading font-bold text-sm text-navy mt-2">{r.title}</div>
                  <div className="text-[11px] text-muted-foreground leading-tight mt-0.5">{r.desc}</div>
                </button>
              );
            })}
          </div>
          <form onSubmit={submit} className="space-y-3 mt-4">
            <Input data-testid="reg-name" placeholder="Nama lengkap" value={form.name} onChange={set("name")} className="rounded-xl h-11" required />
            <Input data-testid="reg-email" type="email" placeholder="Email" value={form.email} onChange={set("email")} className="rounded-xl h-11" required />
            <Input data-testid="reg-password" type="password" placeholder="Password (min 6)" value={form.password} onChange={set("password")} className="rounded-xl h-11" required />
            <button type="submit" disabled={busy} data-testid="reg-submit"
              className="w-full rounded-full bg-lime hover:bg-lime-dark text-navy font-bold py-3 transition-colors disabled:opacity-60">
              {busy ? "..." : "Buat Akun"}
            </button>
          </form>
          <p className="text-sm text-center mt-5 text-muted-foreground">
            Sudah punya akun? <Link to="/login" data-testid="go-login" className="font-bold text-navy underline">Masuk</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
